export default {
    setVacationDates(state, vacationDates) {
        state.vacationDates = vacationDates;
    },
    setError(state, error) {
        state.error = error.toString();
    },
};
